module.exports = __webpack_public_path__ + "static/media/banner2.adbcd363.jpg";